import { MatDialogConfig } from '@angular/material/dialog';

export const dialogConfig: MatDialogConfig = {
  id: 'metric-mapping-dialog',
  height: 'initial',
  width: '92%',
  maxWidth: '1200px',
  panelClass: 'metric-mapping-container'
};
